const ALERT_VARIANTS = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'] as const;

// ----------------------------------------------------------------------------

export { ALERT_VARIANTS };
